import { PurchaseOrderLineValue } from './purchase-order-line-value';
import { PurchaseOrderStatusItem } from './purchase-order-status-item';
import { PurchaseOrderDocumentStatusItem } from './purchase-order-document-status-item';

export interface PurchaseOrderHeaderDetails {
  id: string;
  orderNo: number;
  supplierKey: string;
  supplierName: string;
  supplierId: string;
  supplierContactId: string;
  supplierOrderNo: string;
  supplierOrderRef: string;
  productionProcessId: string;
  productionProcessDescription: string;
  dateOrdered: Date;
  dateEntered: Date;
  confirmationPrinted: boolean;
  orderSourceId: string;
  orderTypeId: string;
  purchaseOrderStatusId: string;
  creditPassed: boolean;
  creditPassedBy: string;
  creditPassedDate: Date;
  supplierAddressMultiLine: string;
  paymentTermId: string;
  currencyId: string;
  settlementTermId: string;
  sellingCompanyId: string;
  taxId: string;
  vATRegNo: string;
  proformaPaid: boolean;
  serviceRepId: string;
  bankId: string;
  proformaOrder: boolean;
  deliveryAddressId: string;
  deliveryAddressMultiLine: string;
  invoiceAddressId: string;
  invoiceAddressMultiLine: string;
  shipperSupplierId: string;
  portId: string;
  modeOfTransportId: string;
  deliveryTermId: string;
  chargeDelivery: boolean;
  orderLineValue: number;
  discountValue: number;
  deliveryItemValue: number;
  extraItemValue: number;
  nettValue: number;
  taxValue: number;
  overallValue: number;
  urgent: boolean;
  promisedDate: Date;
  notes: string;
  warehouseId: string;
  deliveryAddresseeId: string;
  deliveryAddressee: string;
  invoiceAddresseeId: string;
  invoiceAddressee: string;
  pickingListPrinted: boolean;
  pickingListPrintedDate: Date;
  orderConfirmed: boolean;
  orderConfirmedString: string;
  hasRequirements: boolean;

  purchaseOrderStatusItems: PurchaseOrderStatusItem[];
  purchaseOrderDocumentStatusItems: PurchaseOrderDocumentStatusItem[];
  purchaseOrderLineValues: PurchaseOrderLineValue[];
}
